import React, { useEffect, useState } from 'react';
import {
  FacebookShareButton,
  WhatsappShareButton,
  ViberShareButton,
  TwitterShareButton,
  FacebookIcon,
  WhatsappIcon,
  ViberIcon,
  XIcon,
} from "react-share";
import { startSolutionGeneration } from '../services/apiService';
import { useTranslation } from 'react-i18next';

// Define a type for the component's props
type ShareButtonsProps = {
  solutionId: string
};

const ShareButtons: React.FC<ShareButtonsProps> = ({ solutionId }) => {
  const { t } = useTranslation();
  // Optional: format your title into a hashtag for Facebook and Twitter
  const hashtag = '#klikero';
  const [sharingLink, setSharingLink] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  const title = t('sharingButtons.title');

  useEffect(() => {
    const fetchSharedLink = async (solutionId: string) => {
      try {
        const data = await startSolutionGeneration(solutionId);
        const link = data?.solution_page_url || '';

        setSharingLink(link);
      } catch (err) {
        setError(err instanceof Error ? err.message : t('sharingButtons.unknownError'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchSharedLink(solutionId);
  }, [solutionId]);

  return (
    <div style={{ display: 'flex', gap: '10px' }}> {/* 2. Added some basic styling for spacing */}
      <FacebookShareButton url={sharingLink} hashtag={hashtag}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <TwitterShareButton url={sharingLink} title={title} hashtags={[hashtag.substring(1)]}>
        <XIcon size={32} round />
      </TwitterShareButton>
      <WhatsappShareButton className='mobile-only' url={sharingLink} title={sharingLink} separator=":: ">
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>
      <ViberShareButton className='mobile-only' url={sharingLink} title={title}>
        <ViberIcon size={32} round />
      </ViberShareButton>
    </div>
  );
};

export default ShareButtons;